<template>
  <main id="app">
    <header-nav-vue class="app-header" v-if="!$route.meta.hiddenNav" />
    <keep-alive :include="['Relic', 'Report', 'GisList', 'Manage']">
      <router-view
        class="app-content"
        :class="{ 'app-large-content': $route.meta.hiddenNav }"
      ></router-view>
    </keep-alive>
  </main>
</template>

<script>
import headerNavVue from './components/layout/header-nav.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { roleJudge } from './config/roleJudge';

export default {
  name: 'App',
  components: {
    headerNavVue
  },
  computed: {
    ...mapGetters('login', [
      'authToken',
      'limitShow',
      'authorizationLimit',
      'isMobile'
    ])
  },
  mounted() {
    const isMobile = this.isPhone();
    this.setIsMobile(isMobile);
    //
    const visibleEx = JSON.parse(process.env.VUE_APP_VISIBLE_EX);

    this.setVisibleEx(visibleEx);
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.handleLimit();
      }
    }
  },
  data() {
    return {
      navItem: '',
      test: 1
    };
  },
  methods: {
    ...mapMutations('login', ['setLimitShow', 'setIsMobile', 'setVisibleEx']),
    handleLimit() {
      let limit = '';
      if (this.$route.name == 'Manage') {
        limit = roleJudge(this.authorizationLimit, 1);
        this.setLimitShow(limit);
      } else if (
        this.$route.name == 'Relic' ||
        this.$route.name == 'ReportDetail'
      ) {
        limit = roleJudge(this.authorizationLimit, 1, 2);
        this.setLimitShow(limit);
      } else if (
        this.$route.name == 'Report' ||
        this.$route.name == 'ReportDetail'
      ) {
        limit = roleJudge(this.authorizationLimit, 1, 2, 4);
        this.setLimitShow(limit);
      } else if (this.$route.name == 'GisList') {
        limit = roleJudge(this.authorizationLimit, 1, 2, 3);
        this.setLimitShow(limit);
      } else if (this.$route.name == 'RepairList') {
        limit = roleJudge(this.authorizationLimit, 1, 2, 3, 4);
        this.setLimitShow(limit);
      }
    },
    isPhone() {
      const mobileArry = [
        'iPhone',
        'iPad',
        'Android',
        'Windows Phone',
        'BB10; Touch',
        'BB10; Touch',
        'PlayBook',
        'Nokia',
        'iPod'
      ];
      const ua = navigator.userAgent;
      const res = mobileArry.filter(function(arr) {
        return ua.indexOf(arr) > 0;
      });
      return res.length > 0;
    }
  }
};
</script>

<style lang="scss">
#app {
  height: 100%;
  .app {
    &-header {
      margin: 0 auto;
      width: 1024px;
    }
    &-content {
      margin: auto;
      min-height: 100%;
      width: 1024px;
    }
    &-large-content {
      width: 100%;
    }
  }
}
</style>
